/* eslint-disable max-len */
import React from 'react';

const SearchIcon = props => (
  <svg width={13} height={13} viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="giphy-Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Giphy-window" transform="translate(-234.000000, -20.000000)">
        <rect fill="#FFF" x="0" y="0" width="265" height="383" />
        <rect fill="#FFF" x="0" y="0" width="265" height="360" rx="2" />
        <g
          id="giphy-Find-Member-Copy"
          opacity="0.7"
          transform="translate(234.000000, 20.000000)"
          fill="currentColor"
          fillRule="nonzero"
        >
          <g id="giphy-Find-Member">
            <g id="giphy-Search-Icon">
              <path d="M9.90458476,9 L12.9363236,12.0724408 C13.0131754,12.1503243 13.0131754,12.2755077 12.9363236,12.3533913 L12.3127143,12.9853727 C12.3120899,12.9860055 12.3114612,12.9866341 12.3108284,12.9872586 C12.2322045,13.0648409 12.1055743,13.0639966 12.027992,12.9853727 L9,9.91672906 L9.90458476,9 Z M5.5,11 C2.46243388,11 0,8.53756612 0,5.5 C0,2.46243388 2.46243388,0 5.5,0 C8.53756612,0 11,2.46243388 11,5.5 C11,8.53756612 8.53756612,11 5.5,11 Z M5.5,10 C7.98528137,10 10,7.98528137 10,5.5 C10,3.01471863 7.98528137,1 5.5,1 C3.01471863,1 1,3.01471863 1,5.5 C1,7.98528137 3.01471863,10 5.5,10 Z" />
            </g>
          </g>
        </g>
        <path
          d="M18.4852814,366.263456 L25.2487373,359.5 L263,359.5 C263.828427,359.5 264.5,358.828427 264.5,358 L264.5,2 C264.5,1.17157288 263.828427,0.5 263,0.5 L2,0.5 C1.17157288,0.5 0.5,1.17157288 0.5,2 L0.5,358 C0.5,358.828427 1.17157288,359.5 2,359.5 L11.7218254,359.5 L18.4852814,366.263456 Z"
          id="Combined-Shape"
          strokeOpacity="0.2"
          stroke="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default SearchIcon;
